<template>
  <div class="p-15">
    <el-card>
      <el-form ref="ruleForm" :model="searchForm" inline>
        <el-form-item prop="content">
          <el-input placeholder="请输入关键词" v-model.trim="searchForm.content" clearable>
            <el-select v-model="searchForm.field" slot="prepend" placeholder="请选择" style="width: 120px">
              <el-option v-for="item in SEARCH_FIELD" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item prop="query.source">
          <el-select v-model="searchForm.query.source" placeholder="订单来源" style="width: 120px">
            <el-option v-for="item in ORDER_SOURCE.options()" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="query.shipping_status">
          <el-select v-model="searchForm.query.shipping_status" placeholder="订单状态" style="width: 120px">
            <el-option v-for="item in ORDER_STATUS.options()" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="date_range">
          <el-date-picker
              v-model="searchForm.date_range"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="下单开始时间"
              end-placeholder="下单结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetPagination" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleExport(exportUrl, {type: ORDER_TYPE.invented})" type="primary">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-t-20" header="虚拟订单">
      <el-table :data="table_data">
        <el-table-column label="订单编号/来源">
          <template slot-scope="{row}">
            <div>
              <router-link :to="{name:'order-fictitious-detail',query:{id:row.id}}">
                <el-link type="primary">{{ row.sn }}</el-link>
              </router-link>
            </div>
            <div>
              {{ ORDER_SOURCE.filterValue(row.source) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="购买商品">
          <template slot-scope="{row}">
            <div>
              {{ row.giftCode }} / x{{ row.quantity }} / {{ row.giftTitle }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="消耗积分" prop="creditTotal" width="120px"></el-table-column>
        <el-table-column label="用户昵称/下单时间" width="200px">
          <template slot-scope="{row}">
            <div class="text-ellipsis">
              {{ row.nickname }}
            </div>
            <div class="text-ellipsis">
              {{ row.createdAt }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="120px">
          <template slot-scope="{row}">
            <badge :badge_type="ORDER_STATUS.giftBadge(GIFT_ORDER_STATUS.getStatus(row))">{{ ORDER_STATUS.giftFilterValue(GIFT_ORDER_STATUS.getStatus(row)) }}</badge>
          </template>
        </el-table-column>
      </el-table>
      <pagination :changed="changePage" :total="total" :pagination="searchForm.pagination"/>
    </el-card>
  </div>
</template>

<script>
import {ORDER_SOURCE, ORDER_STATUS, SEARCH_FIELD,GIFT_ORDER_STATUS, ORDER_TYPE} from "@/enums/order";
import {getInventedList, exportUrl} from "@/api/order";
import {exportStockUrl} from "@/api/gift";

export default {
  name: "material",
  data() {
    return {
      total: 0,
      table_data: [],
      searchForm: {
        query: {
          source: undefined,
          shipping_status: undefined,
        },
        content: undefined,
        field: 'sn',

        date_range: [],
        pagination: {
          currentPage: 1,
          limit: 10
        }
      },

      SEARCH_FIELD,
      ORDER_SOURCE,
      ORDER_STATUS,
      GIFT_ORDER_STATUS,
      ORDER_TYPE,
      exportUrl
    }
  },
  methods: {
    resetPagination() {
      this.searchForm.pagination = { currentPage: 1, limit: 10 }
      this.init()
    },
    getStatus(row){
      if(row.status == 'completed'){
        return 'completed'
      }else if(row.status == 'normal' && row.shippingStatus == 'shipped'){
        return 'shipped'
      }else if(row.status == 'normal' && row.shippingStatus == 'unshipped'){
        return 'unshipped'
      }else if(row.status == 'cancelled'){
        return 'cancelled'
      }
    },
    changePage(page) {
      this.searchForm = Object.assign(this.searchForm, page)
      this.init()
    },
    async init() {
      const {collection, meta} = await getInventedList(this.searchForm)
      this.table_data = collection
      this.total = meta.total
    },
    reset() {
      this.$refs.ruleForm.resetFields()
      this.init()
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>